<template>
  <div>
    <div v-if="items && items.length > 0">
      <div
        v-for="(barrier, index) in items"
        :key="index"
        :class="[
          'flex',
          'flex-row',
          'list-item',
          'mb1',
          'has-position-relative',
        ]"
      >
        <!-- Relative positioning context for the overlay -->
        <div class="flex cell">
          <div class="flex cell flex-column">
            <b
              :class="[
                'shared-list-item-title',
                'is-ellipsis',
                'mbx',
                'mrx',
                $style.title,
              ]"
            >
              {{ barrier.title }}
            </b>
            <p
              v-if="barrier.gripDomainCategory"
              :class="['shared-list-item-category-box', 'mbx']"
            >
              {{ getUpperCase(barrier.gripDomainCategory.name) }}
            </p>
            <p :class="['is-ellipsis', 'mrx', $style.description]">
              {{ barrier.description }}
            </p>
          </div>
          <div>
            <a @click="handleEdit(barrier)" class="is-text-info prs">
              <b-icon icon="pencil" size="is-small" />
            </a>
            <a
              @click="$emit('delete-barrier-request', barrier.id)"
              class="is-text-info"
            >
              <b-icon icon="delete" size="is-small" />
            </a>
          </div>

          <!-- Conditionally render overlay if this barrier is being edited -->
          <div
            v-if="barrier.id === editingBarrierId && isMinimized"
            class="shared-list-item-edit-overlay"
            @click="$emit('restore-from-overlay')"
          >
            <!-- Content of the overlay -->
            <span class="shared-list-item-overlay-text"
              >Resume Edit <i class="mdi mdi-arrow-expand"></i
            ></span>
          </div>

          <!-- END NEW OVERLAY -->
        </div>
      </div>
    </div>
    <div v-else :class="['flex', 'flex-row', 'list-item', 'mb1']">
      <div class="flex cell flex-column">
        <p class="text-size align-center text-color bold">No data found</p>
      </div>
    </div>
    <BasePagination
      v-if="items && items.length > 0"
      :class="$style.pagination"
      :page.sync="page"
      :perPage.sync="perPage"
      :totalNumberOfPage="totalNumberOfPage"
      :totalCount="totalCount"
      :isFirstPage="isFirstPage"
      :isLastPage="isLastPage"
      :startItemIndex="startItemIndex"
      :endItemIndex="endItemIndex"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import { GripBarrier } from '../../../store/types/grip.types';
import BasePagination from '../../../components/base/BasePagination.vue';
import { PaginationMixin } from '../../../components/base/pagination.mixin';
import { mixins } from 'vue-class-component';
import { getUpperCase } from '../../../utils/general.util';

@Component({
  components: { BasePagination },
})
export default class BarrierList extends mixins(PaginationMixin) {
  @Prop() public items!: GripBarrier[];
  @Prop(Number) public totalNumberOfPage!: number;
  @Prop(Number) public totalCount!: number;
  @Prop(Boolean) public isFirstPage!: boolean;
  @Prop(Boolean) public isLastPage!: boolean;
  @Prop(Number) public startItemIndex!: number;
  @Prop(Number) public endItemIndex!: number;
  // Receive the ID of the barrier currently being edited from the parent
  @Prop({ type: Number, default: null }) public editingBarrierId!:
    | number
    | null;
  // Receive the minimized state from the parent
  @Prop({ type: Boolean, default: false }) public isMinimized!: boolean;

  get projectId(): number {
    return +this.$route.params.projectId;
  }

  public getUpperCase(value: string) {
    return getUpperCase(value);
  }

  public handleEdit(barrier: GripBarrier): void {
    // Instead of opening a local modal, emit an event with the barrier data
    this.$emit('edit-barrier', barrier);
  }
}
</script>
<style lang="scss" module>
.title {
  line-height: 1.0625rem; /* 17px */
  max-width: 70ch;
}

.description {
  max-width: 70ch;
}

.pagination nav {
  border-right: none !important;
}

.pagination nav ul {
  max-width: none !important;
}

.pagination nav li a,
.settingTabs nav li a:hover {
  height: auto !important;
  width: auto !important;
  font-size: 1rem !important;
  line-height: inherit !important;
  margin: 0.25rem !important;
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
  text-align: center !important;
  justify-content: center !important;
}
</style>
